import { DefaultState } from 'store/reducers/types';

export const READ_ASSIGNMENT_REPORT_DATA_REQUEST = 'READ_ASSIGNMENT_REPORT_DATA_REQUEST';
export const READ_ASSIGNMENT_REPORT_DATA_SUCCESS = 'READ_ASSIGNMENT_REPORT_DATA_SUCCESS';
export const READ_ASSIGNMENT_REPORT_DATA_FAILURE = 'READ_ASSIGNMENT_REPORT_DATA_FAILURE';

export type AssignmentReportData = any;

export type AssignmentReportState = DefaultState & {
  contents?: AssignmentReportData;
};

interface ReadAssignmentReportDataRequest {
  type: typeof READ_ASSIGNMENT_REPORT_DATA_REQUEST;
};

interface ReadAssignmentReportDataSuccess {
  type: typeof READ_ASSIGNMENT_REPORT_DATA_SUCCESS,
  contents: AssignmentReportData;
}

interface ReadAssignmentReportDataFailure {
  type: typeof READ_ASSIGNMENT_REPORT_DATA_FAILURE;
}

export type AssignmentReportActionTypes = ReadAssignmentReportDataRequest | ReadAssignmentReportDataSuccess | ReadAssignmentReportDataFailure;